import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { PostsComponent } from '../components/post.component';
import { selectTopicsListItems, selectTopicsQueryItems } from '../../../../../../redux/chapter/topics/selector';
import { chapter } from '../../../../../../redux/chapter/chapters/action';
import { selectChapterListItems } from '../../../../../../redux/chapter/chapters/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { chapterPost } from '../../../../../../redux/chapter/posts/action';
import { topics } from '../../../../../../redux/chapter/topics/action';
import { selectChapterPostQueryItems } from '../../../../../../redux/chapter/posts/selector';

const Post = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const postQuery = useSelector(selectChapterPostQueryItems);
  const topicsItems = useSelector(selectTopicsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const libraryData = useSelector(selectListItems)

  const [selectedPost, setSelectedPost] = useState<any>({
    "Name": "",
    "DisplayOrder": 0,
    "CommunityId": 0

  });

  const fetchForumGroupsQueryById = () => {
    dispatch(chapterPost.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts/query`,
      entity: 'chapterPost',
      jsonData: {
        Context: {},
        Records: [
          {

            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedPost({ ...selectedPost, [field]: event });
  }
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }
  useEffect(() => {
    dispatch(topics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/list`,
      entity: 'topics',
      jsonData: {

      }
    })).then(() => {
      if (parmas?.id > 0) {
        fetchForumGroupsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedPost(postQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const postData = {
      "Id": selectedPost?.Id || 0,
      "ChapterTopicId": selectedPost?.ChapterTopicId,
      "Text": selectedPost?.Text,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": []
      }

    }
    if (parmas?.id > 0) {
      await dispatch(chapterPost.resetAction({ actionType: 'update' }))
      await dispatch(chapterPost.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts`,
        entity: 'chapterPost',
        jsonData: {
          Context: {},
          Records: [
            postData
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(chapterPost.resetAction({ actionType: 'create' }))
      await dispatch(chapterPost.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts`,
        entity: 'chapterPost',
        jsonData: {
          Context: {},
          Records: [
            postData
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/onesp/chapters/posts');
  }


  return (
    <>
      {postQuery?.isLoading ? <PageLoader /> :
        <PostsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedPost={selectedPost}
          back={back}
          handleFormSubmit={handleFormSubmit}
          topics={topicsItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          libraryData={libraryData?.result?.ChapterTopicType}
        />
      }
    </>
  );
}

export default Post;
